export function isNumberValid(
  value?: number | null | undefined
): value is number {
  return (
    typeof value === 'number' &&
    !isNaN(value) &&
    !(value === Number.POSITIVE_INFINITY || value === Number.NEGATIVE_INFINITY)
  );
}
